import React from 'react'
import { css } from '@emotion/core'
import { node } from 'prop-types'

export default function Ribbon({ children, backgroundColor = '#b14403' }) {
  const ribbonFrameCss = css`
    position: relative;
    &:before,
    &:after {
      background-color: ${backgroundColor};
    }
    display: flex;
    padding: 0 51px;

    &:after,
    &:before {
      position: absolute;
      content: '';
      width: 52px;
      height: 100%;
      top: 5px;
    }

    &:before {
      inset-inline-start: 0;
      clip-path: polygon(0 0%, 100% 0, 100% 100%, 0 100%, 35% 50%);
    }

    &:after {
      inset-inline-end: 0;
      clip-path: polygon(0 0, 100% 0, 65% 50%, 100% 100%, 0 100%);
    }
  `

  const ribbonLabelCss = css`
    color: #fff;
    background: ${backgroundColor};
    font-size: 20px;
    line-height: 100%;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
    width: 100%;
    padding: 14px 20px;
    position: relative;
    z-index: 1;
    text-align: center;
  `
  return (
    <div css={ribbonFrameCss}>
      <div
        data-testid="ribbon-points-child"
        css={ribbonLabelCss}
        style={{ backgroundColor, fill: '#FFFFFF', fontSize: '40px' }}
      >
        {children}
      </div>
    </div>
  )
}

Ribbon.propTypes = {
  children: node,
}
